<template>
    <i-select :value="value" @input="newValue => $emit('input', newValue)" filterable multiple>
        <i-option value="Protracted">Protracted</i-option>
        <i-option value="Chronic/repeated displacement">Chronic/repeated displacement</i-option>
        <i-option value="Indigenous communities affected">Indigenous communities affected</i-option>
        <i-option value="Crime-induced displacement">Crime-induced displacement</i-option>
        <i-option value="Multi-causality">Multi-causality</i-option>
        <i-option value="Transboundary disaster">Transboundary disaster</i-option>
        <i-option value="Food Insecurity">Food Insecurity</i-option>
    </i-select>
</template>

<script>
export default {
  name: "ThemeSelect",
  props: ["value"],
};
</script>
